import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import { connect } from 'react-redux';

import Button from 'react-bootstrap/Button';

import * as actions from '../../../store/actions/index';

import { confirmAlert } from 'react-confirm-alert'; // Import
import 'react-confirm-alert/src/react-confirm-alert.css'; // Import css

import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

import classes from './Logout.css';

class Logout extends Component {
    componentDidMount () {

        confirmAlert({
            customUI: ({ onClose }) => {
              return (
                <div className='custom-ui'>
                    
                    <Container>
                        <Row>
                            <Col>
                            <h1>Are you sure?</h1>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                            <p>Log out of your BookMeeY page</p>
                            </Col>
                        </Row>
                        <div className={classes.Logout}>
                        <Row>
                            <Col>
                                <Button variant="info"
                                    onClick={() => {
                                        this.props.onLogout();
                                        onClose();
                                    }}
                                    block
                                >
                                Yes
                                </Button> 
                            </Col>
                            <Col>
                                <Button variant="outline-info" onClick={onClose} block>No</Button>
                            </Col>
                        </Row>
                        </div>
                    </Container>
                    
                </div>
              );
            }
          });
    }

    render () {
        return <Redirect to="/profile"/>;
    }
}

const mapDispatchToProps = dispatch => {
    return {
        onLogout: () => dispatch(actions.logout())
    };
};

export default connect(null, mapDispatchToProps)(Logout);


// WEBPACK FOOTER //
// ./src/containers/Auth/Logout/Logout.js